import { Component, OnInit, Input, Inject } from '@angular/core';
import { Hotel } from '../../api/model/hotel/hotel.model';
import { SiteURLUtils } from '../../common/site.url.utils';
import { IAppConfig } from '../../store';
import { APP_CONFIG } from '../../api/config';
import { NgRedux } from '@angular-redux/store';
import { IAppState } from '../../store/interfaces/IAppState';
import { useDefault } from '../../common/common';

@Component({
  selector: 'stay-mgmt-hotel-brand-info',
  templateUrl: './hotel-brand-info.component.html',
  styleUrls: ['./hotel-brand-info.component.scss']
})
export class HotelBrandInfoComponent implements OnInit {
  @Input() hotel: Hotel;
  @Input() disableLinks: boolean;

  ARMY_INDEPENDENT: string[] = ['MAMI'];
  SP_BRANDS: string[] = ['SPND', 'SPCT', 'SP', 'ND', 'CT'];

  state: IAppState;
  displayBrandName = true;
  hotelDetailUrl: string;

  constructor
    (@Inject(APP_CONFIG) protected appConfig: IAppConfig,
      private _ngRedux: NgRedux<IAppState>) { }


  ngOnInit() {
    this.updateFromState();
    this.displayBrandHotel();
    this.setHotelDetailUrl();

    this._ngRedux.subscribe(() => {
      this.updateFromState();
      this.displayBrandHotel();
      this.setHotelDetailUrl();
    });
  }

  updateFromState() {
    this.state = this._ngRedux.getState();
    this.hotel = useDefault(this.state.hotel, new Hotel());
  }

  displayBrandHotel() {
    if (!this.hotel.brandCode || this.SP_BRANDS.indexOf(this.hotel.brandCode.toUpperCase()) >= 0 ||
      this.ARMY_INDEPENDENT.indexOf(this.hotel.brandCode.toUpperCase()) >= 0) {
      this.displayBrandName = false;
    } else {
      this.displayBrandName = true;
    }
  }

  setHotelDetailUrl() {
    this.hotelDetailUrl = SiteURLUtils.getLocalizedHotelDetailsUrl(this.appConfig, this.hotel.mnemonic, this.hotel.seoCity, this.hotel.brandCode);
  }
}



// WEBPACK FOOTER //
// ./src/main/webapp/stay-mgmt/app/components/hotel-brand-info/hotel-brand-info.component.ts